import React from 'react';
import { findDOMNode } from 'react-dom';

import _ from 'lodash';

//dnd
import { DragSource, DropTarget } from 'react-dnd';

const cardSource = {
    beginDrag(props) {
        gd.bus.triggerEvent('dropzone:disable');

        if (props.onDragStart) props.onDragStart();

        return {
            index: props.index,
            item: props.item
        };
    },

    endDrag(props, monitor) {
        gd.bus.triggerEvent('dropzone:enable');

        if (props.onDragEnd){
            props.onDragEnd(monitor.getItem().item);
        }
    },

    isDragging(props, monitor) {
        return _.isEqualWith(props.item, monitor.getItem().item, (objValue, othValue)=>objValue === othValue);
    }
};

const cardTarget = {
    hover(props, monitor, component) {
        const dragIndex = monitor.getItem().index;
        const hoverIndex = props.index;

        // Don't replace items with themselves
        if (dragIndex === hoverIndex) {
            return;
        }

        // Determine rectangle on screen
        const hoverBoundingRect = findDOMNode(component).getBoundingClientRect();

        // Get vertical middle
        const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;

        // Determine mouse position
        const clientOffset = monitor.getClientOffset();

        // Get pixels to the top
        const hoverClientY = clientOffset.y - hoverBoundingRect.top;

        // Only perform the move when the mouse has crossed half of the items height
        // When dragging downwards, only move when the cursor is below 50%
        // When dragging upwards, only move when the cursor is above 50%

        // Dragging downwards
        if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
            return;
        }

        // Dragging upwards
        if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
            return;
        }

        // Time to actually perform the action
        props.moveCard(dragIndex, hoverIndex);

        // Note: we're mutating the monitor item here!
        // Generally it's better to avoid mutations,
        // but it's good here for the sake of performance
        // to avoid expensive index searches.
        monitor.getItem().index = hoverIndex;
    }
};

function collectTarget(connect) {
    return {
        connectDropTarget: connect.dropTarget()
    }
}

function collectSource(connect, monitor) {
    return {
        connectDragSource: connect.dragSource(),
        connectDragPreview: connect.dragPreview(),
        isDragging: monitor.isDragging()
    }
}

export const dragSource = DragSource(exports=>exports.dragSourceType, cardSource, collectSource);
export const dropTarget = DropTarget(exports=>exports.dragSourceType, cardTarget, collectTarget);